module.exports = __webpack_public_path__ + "img/HighStandardDeviation.ce62ca72.png";